export default "__VITE_ASSET__BSRhwzvH__"